import React, { FC } from 'react';
import { DataTable, ColumnConfig } from '../../../DataTable';
import { PositionsReport } from '../../OpenClosedPositionsSummaryModel';

interface Props {
  columns: ColumnConfig<PositionsReport>[];
  rows: PositionsReport[];
  selectedColumns: string[];
  translation: any;
  onSelectColumns(columns: string[]): void;
}

export const ReportTable: FC<Props> = ({ rows, columns, selectedColumns, translation, onSelectColumns }) => (
  <DataTable columns={columns} data={rows} translation={translation} columnSelect selectedColumns={selectedColumns} onSelectColumns={onSelectColumns} emptyMessage={translation.text_6448} />
);
